import * as React from 'react';
import * as styles from './defaultLoader.scss';

export class DefaultLoader extends React.Component {
  render() {
    return (
      <div className={styles.loader} data-hook="tour-default-loader"></div>
    );
  }
}
